export type WellCoords = {
  /** x axis is equivalent to column on plate */
  x: number;
  /** y axis is equivalent to row on plate */
  y: number;
};

/**
 * @returns wells column-wise to end
 * @default start - A1
 * @example {end: {x: 2, y: 2}} gives ["A1", "B1", "A2", "B2"]
 */
export const makeWellCoordsRegion = (opts: { start?: WellCoords; end: WellCoords }) => {
  const result = [];
  const { start = { x: 0, y: 0 }, end } = opts;
  for (let x = start.x; x < end.x; x++) {
    for (let y = start.y; y < end.y; y++) {
      result.push({ x, y });
    }
  }
  return result;
};

/**
 * @returns wellCoords in A1-format
 * @example
 *  {x: 0, y: 0} -> "A1"
 *  {x: 0, y: 2} -> "C1"
 *  {x: 47, y: 31} -> "AF48"
 *  {x: -1, y: 23} -> "" // invalid
 */
export const formatWellCoords = ({ x, y }: WellCoords): string => {
  if (x < 0 || y < 0) {
    return '';
  }
  return `${getRowLabel(y)}${x + 1}`;
};

// Excel-style labels: A…Z, AA…AZ, BA…
// charCode 65 === A, 66 === B etc
export const getRowLabels = (n: number): string[] =>
  Array.from({ length: n }, (_, i) => getRowLabel(i));

export const getColumnLabels = (n: number) => Array.from({ length: n }, (_, i) => i + 1);

const getRowLabel = (n: number) => {
  return n < 26
    ? String.fromCharCode(65 + n) // A-Z
    : String.fromCharCode(64 + Math.floor(n / 26)) + // 1st letter
        String.fromCharCode(65 + (n % 26)); // 2nd letter
};
